import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a194b75"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Confirmar", -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "ant-row" }
const _hoisted_4 = { class: "ant-col-xl-9 ant-col-xs-9" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_6 = { class: "ant-row" }
const _hoisted_7 = { class: "ant-col-xl-12 ant-col-xs-12" }
const _hoisted_8 = { class: "ant-row" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-span-tipo-campo ant-col-xl-24 ant-col-xs24" }, "Texto")
], -1))
const _hoisted_10 = { class: "ant-col-xl-12 ant-col-xs-12" }
const _hoisted_11 = { class: "ant-row" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-span-tipo-campo-pequeno ant-col-xl-24 ant-col-xs24" }, "Área de Texto")
], -1))
const _hoisted_13 = { class: "ant-row" }
const _hoisted_14 = { class: "ant-col-xl-12 ant-col-xs-12" }
const _hoisted_15 = { class: "ant-row" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-span-tipo-campo ant-col-xl-24 ant-col-xs24" }, "Inteiro")
], -1))
const _hoisted_17 = { class: "ant-col-xl-12 ant-col-xs-12" }
const _hoisted_18 = { class: "ant-row" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-span-tipo-campo ant-col-xl-24 ant-col-xs24" }, "Fracionado")
], -1))
const _hoisted_20 = { class: "ant-row" }
const _hoisted_21 = { class: "ant-col-xl-12 ant-col-xs-12" }
const _hoisted_22 = { class: "ant-row" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-span-tipo-campo ant-col-xl-24 ant-col-xs24" }, "E-mail")
], -1))
const _hoisted_24 = { class: "ant-col-xl-12 ant-col-xs-12" }
const _hoisted_25 = { class: "ant-row" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-span-tipo-campo ant-col-xl-24 ant-col-xs24" }, "Senha")
], -1))
const _hoisted_27 = { class: "ant-row" }
const _hoisted_28 = { class: "ant-col-xl-12 ant-col-xs-12" }
const _hoisted_29 = { class: "ant-row" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-span-tipo-campo ant-col-xl-24 ant-col-xs24" }, "Combo")
], -1))
const _hoisted_31 = { class: "ant-col-xl-12 ant-col-xs-12" }
const _hoisted_32 = { class: "ant-row" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-span-tipo-campo-pequeno ant-col-xl-24 ant-col-xs24" }, "Lista de Seleção")
], -1))
const _hoisted_34 = { class: "ant-row" }
const _hoisted_35 = { class: "ant-col-xl-12 ant-col-xs-12" }
const _hoisted_36 = { class: "ant-row" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-span-tipo-campo ant-col-xl-24 ant-col-xs24" }, "Data")
], -1))
const _hoisted_38 = { class: "ant-col-xl-12 ant-col-xs-12" }
const _hoisted_39 = { class: "ant-row" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-span-tipo-campo ant-col-xl-24 ant-col-xs24" }, "Hora")
], -1))
const _hoisted_41 = { class: "ant-row" }
const _hoisted_42 = { class: "ant-col-xl-12 ant-col-xs-12" }
const _hoisted_43 = { class: "ant-row" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-span-tipo-campo ant-col-xl-24 ant-col-xs24" }, "Check")
], -1))
const _hoisted_45 = { class: "ant-col-xl-12 ant-col-xs-12" }
const _hoisted_46 = { class: "ant-row" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-span-tipo-campo ant-col-xl-24 ant-col-xs24" }, "Switch")
], -1))
const _hoisted_48 = { class: "ant-col-xl-15 ant-col-xs-15" }
const _hoisted_49 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_50 = ["readonly"]
const _hoisted_51 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_52 = { class: "ant-col-xl-24 ant-col-xs-24" }
const _hoisted_53 = ["maxlength"]
const _hoisted_54 = {
  key: 1,
  class: "ant-row"
}
const _hoisted_55 = { class: "ant-col-xl-12 ant-col-xs-12" }
const _hoisted_56 = { class: "ant-col-xl-12 ant-col-xs-12" }
const _hoisted_57 = {
  key: 2,
  class: "ant-row"
}
const _hoisted_58 = { class: "ant-col-xl-24 ant-col-xs-24" }
const _hoisted_59 = {
  key: 3,
  class: "ant-row"
}
const _hoisted_60 = { class: "ant-col-xl-24 ant-col-xs-24" }
const _hoisted_61 = {
  key: 4,
  class: "ant-row"
}
const _hoisted_62 = { class: "ant-col-xl-24 ant-col-xs-24" }
const _hoisted_63 = {
  key: 5,
  class: "ant-row"
}
const _hoisted_64 = { class: "ant-col-xl-24 ant-col-xs-24" }
const _hoisted_65 = {
  key: 6,
  class: "ant-row"
}
const _hoisted_66 = { class: "ant-col-xl-24 ant-col-xs-24" }
const _hoisted_67 = {
  key: 7,
  class: "ant-row"
}
const _hoisted_68 = { class: "ant-row" }
const _hoisted_69 = { class: "ant-col-xl-6 ant-col-xs-6" }
const _hoisted_70 = { class: "ant-col-xl-11 ant-col-xs-11" }
const _hoisted_71 = { class: "ant-col-xl-5 ant-col-xs-5" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Adicionar", -1))
const _hoisted_73 = [
  _hoisted_72
]
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row ss-grade-personalizada-titulo" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-7 ant-col-xl-7" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Valor")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-13 ant-col-xl-13" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Descrição")
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "ant-col",
    style: {"margin-left":"5px"}
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Ações")
  ])
], -1))
const _hoisted_75 = { class: "ant-col ant-col-xs-7 ant-col-xl-7" }
const _hoisted_76 = { class: "ss-margin-campos" }
const _hoisted_77 = ["onUpdate:modelValue"]
const _hoisted_78 = { class: "ant-col ant-col-xs-13 ant-col-xl-13" }
const _hoisted_79 = { class: "ss-margin-campos" }
const _hoisted_80 = ["onUpdate:modelValue"]
const _hoisted_81 = { class: "ant-col" }
const _hoisted_82 = ["onClick"]
const _hoisted_83 = {
  key: 9,
  class: "ant-row"
}
const _hoisted_84 = { class: "ant-col-xl-12 ant-col-xs-12" }
const _hoisted_85 = { class: "ant-col-xl-12 ant-col-xs-12" }
const _hoisted_86 = {
  key: 10,
  class: "ant-row"
}
const _hoisted_87 = { class: "ant-col-xl-24 ant-col-xs-24" }
const _hoisted_88 = { class: "ant-row" }
const _hoisted_89 = { class: "ant-col-xl-12 ant-col-xs-12" }
const _hoisted_90 = { class: "ant-col-xl-12 ant-col-xs-12" }
const _hoisted_91 = { class: "ant-row" }
const _hoisted_92 = { class: "ant-col-xl-12 ant-col-xs-12" }
const _hoisted_93 = { class: "ant-col-xl-12 ant-col-xs-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_card = _resolveComponent("card")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_selecionar_valor_campo_personalizado = _resolveComponent("selecionar-valor-campo-personalizado")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_selecionar_hora = _resolveComponent("selecionar-hora")!
  const _component_selecionar_boolean = _resolveComponent("selecionar-boolean")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_selecionar_sim_nao = _resolveComponent("selecionar-sim-nao")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      keyboard: false,
      visible: _ctx.modalBase.computedVisivel,
      "onUpdate:visible": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
      style: {"width":"750px"}
    }, {
      title: _withCtx(() => [
        _createTextVNode("Campo Personalizado")
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "button",
            class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.confirmar && _ctx.confirmar(...args)))
          }, _hoisted_2)
        ])
      ]),
      closeIcon: _withCtx(() => [
        _createVNode(_component_icone, { nome: "voltar" })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_card, {
              class: "ss-card",
              titulo: "Tipos de Campo"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(_ctx.obterClasseBotao(_ctx.ETipoCampoPersonalizado.Texto)),
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selecionarTipo(_ctx.ETipoCampoPersonalizado.Texto)))
                      }, [
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_icone, {
                            class: "ss-icone-tipo-campo ant-col-xl-24 ant-col-xs24",
                            nome: "texto"
                          })
                        ]),
                        _hoisted_9
                      ], 2)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(_ctx.obterClasseBotao(_ctx.ETipoCampoPersonalizado.AreaTexto)),
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selecionarTipo(_ctx.ETipoCampoPersonalizado.AreaTexto)))
                      }, [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_icone, {
                            class: "ss-icone-tipo-campo ant-col-xl-24 ant-col-xs24",
                            nome: "area-texto"
                          })
                        ]),
                        _hoisted_12
                      ], 2)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(_ctx.obterClasseBotao(_ctx.ETipoCampoPersonalizado.Inteiro)),
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selecionarTipo(_ctx.ETipoCampoPersonalizado.Inteiro)))
                      }, [
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(_component_icone, {
                            class: "ss-icone-tipo-campo ant-col-xl-24 ant-col-xs24",
                            nome: "numero"
                          })
                        ]),
                        _hoisted_16
                      ], 2)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(_ctx.obterClasseBotao(_ctx.ETipoCampoPersonalizado.Fracionado)),
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selecionarTipo(_ctx.ETipoCampoPersonalizado.Fracionado)))
                      }, [
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(_component_icone, {
                            class: "ss-icone-tipo-campo ant-col-xl-24 ant-col-xs24",
                            nome: "dinheiro"
                          })
                        ]),
                        _hoisted_19
                      ], 2)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(_ctx.obterClasseBotao(_ctx.ETipoCampoPersonalizado.Email)),
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selecionarTipo(_ctx.ETipoCampoPersonalizado.Email)))
                      }, [
                        _createElementVNode("div", _hoisted_22, [
                          _createVNode(_component_icone, {
                            class: "ss-icone-tipo-campo ant-col-xl-24 ant-col-xs24",
                            nome: "arroba"
                          })
                        ]),
                        _hoisted_23
                      ], 2)
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(_ctx.obterClasseBotao(_ctx.ETipoCampoPersonalizado.Senha)),
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selecionarTipo(_ctx.ETipoCampoPersonalizado.Senha)))
                      }, [
                        _createElementVNode("div", _hoisted_25, [
                          _createVNode(_component_icone, {
                            class: "ss-icone-tipo-campo ant-col-xl-24 ant-col-xs24",
                            nome: "senha"
                          })
                        ]),
                        _hoisted_26
                      ], 2)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(_ctx.obterClasseBotao(_ctx.ETipoCampoPersonalizado.ComboBox)),
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.selecionarTipo(_ctx.ETipoCampoPersonalizado.ComboBox)))
                      }, [
                        _createElementVNode("div", _hoisted_29, [
                          _createVNode(_component_icone, {
                            class: "ss-icone-tipo-campo ant-col-xl-24 ant-col-xs24",
                            nome: "combobox"
                          })
                        ]),
                        _hoisted_30
                      ], 2)
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(_ctx.obterClasseBotao(_ctx.ETipoCampoPersonalizado.ListaSelecao)),
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.selecionarTipo(_ctx.ETipoCampoPersonalizado.ListaSelecao)))
                      }, [
                        _createElementVNode("div", _hoisted_32, [
                          _createVNode(_component_icone, {
                            class: "ss-icone-tipo-campo ant-col-xl-24 ant-col-xs24",
                            nome: "checklist"
                          })
                        ]),
                        _hoisted_33
                      ], 2)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(_ctx.obterClasseBotao(_ctx.ETipoCampoPersonalizado.Data)),
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.selecionarTipo(_ctx.ETipoCampoPersonalizado.Data)))
                      }, [
                        _createElementVNode("div", _hoisted_36, [
                          _createVNode(_component_icone, {
                            class: "ss-icone-tipo-campo ant-col-xl-24 ant-col-xs24",
                            nome: "calendario"
                          })
                        ]),
                        _hoisted_37
                      ], 2)
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(_ctx.obterClasseBotao(_ctx.ETipoCampoPersonalizado.Hora)),
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.selecionarTipo(_ctx.ETipoCampoPersonalizado.Hora)))
                      }, [
                        _createElementVNode("div", _hoisted_39, [
                          _createVNode(_component_icone, {
                            class: "ss-icone-tipo-campo ant-col-xl-24 ant-col-xs24",
                            nome: "relogio"
                          })
                        ]),
                        _hoisted_40
                      ], 2)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(_ctx.obterClasseBotao(_ctx.ETipoCampoPersonalizado.Check)),
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.selecionarTipo(_ctx.ETipoCampoPersonalizado.Check)))
                      }, [
                        _createElementVNode("div", _hoisted_43, [
                          _createVNode(_component_icone, {
                            class: "ss-icone-tipo-campo ant-col-xl-24 ant-col-xs24",
                            nome: "check"
                          })
                        ]),
                        _hoisted_44
                      ], 2)
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(_ctx.obterClasseBotao(_ctx.ETipoCampoPersonalizado.Switch)),
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.selecionarTipo(_ctx.ETipoCampoPersonalizado.Switch)))
                      }, [
                        _createElementVNode("div", _hoisted_46, [
                          _createVNode(_component_icone, {
                            class: "ss-icone-tipo-campo ant-col-xl-24 ant-col-xs24",
                            nome: "switch"
                          })
                        ]),
                        _hoisted_47
                      ], 2)
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_48, [
            _createVNode(_component_card, {
              class: "ss-card",
              titulo: "Definições do Campo"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_49, [
                  _createVNode(_component_a_form, { layout: "vertical" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, {
                        label: "Identificador",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            maxlength: "250",
                            class: "ant-input",
                            readonly: _ctx.state.campo.codigo > 0,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.campo.identificador) = $event))
                          }, null, 8, _hoisted_50), [
                            [_vModelText, _ctx.state.campo.identificador]
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, {
                        label: "Nome do Campo",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            maxlength: "250",
                            class: "ant-input",
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.campo.nome) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.state.campo.nome]
                          ])
                        ]),
                        _: 1
                      }),
                      (_ctx.validarTipoTexto())
                        ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                            _createElementVNode("div", _hoisted_52, [
                              _createVNode(_component_a_form_item, {
                                label: "Valor Padrão",
                                class: "ss-margin-campos"
                              }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "ant-input",
                                    maxlength: _ctx.obterTamanhoMaximo(),
                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.campo.valorPadrao) = $event))
                                  }, null, 8, _hoisted_53), [
                                    [_vModelText, _ctx.state.campo.valorPadrao]
                                  ])
                                ]),
                                _: 1
                              })
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.state.campo.tipoCampo == _ctx.ETipoCampoPersonalizado.Inteiro)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                            _createElementVNode("div", _hoisted_55, [
                              _createVNode(_component_a_form_item, {
                                label: "Valor Padrão",
                                class: "ss-margin-campos"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_campo_numerico, {
                                    quantidadeCasasDecimais: 0,
                                    valor: _ctx.state.valorPadraoNumerico,
                                    "onUpdate:valor": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.valorPadraoNumerico) = $event))
                                  }, null, 8, ["valor"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_56, [
                              _createVNode(_component_a_form_item, {
                                label: "Máscara",
                                class: "ss-margin-campos"
                              }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    maxlength: "250",
                                    class: "ant-input",
                                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.campo.mascara) = $event))
                                  }, null, 512), [
                                    [_vModelText, _ctx.state.campo.mascara]
                                  ])
                                ]),
                                _: 1
                              })
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.state.campo.tipoCampo == _ctx.ETipoCampoPersonalizado.Fracionado)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                            _createElementVNode("div", _hoisted_58, [
                              _createVNode(_component_a_form_item, {
                                label: "Valor Padrão",
                                class: "ss-margin-campos"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_campo_numerico, {
                                    quantidadeCasasDecimais: 2,
                                    valor: _ctx.state.valorPadraoNumerico,
                                    "onUpdate:valor": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.valorPadraoNumerico) = $event))
                                  }, null, 8, ["valor"])
                                ]),
                                _: 1
                              })
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.validarTipoMultivalorado())
                        ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                            _createElementVNode("div", _hoisted_60, [
                              _createVNode(_component_a_form_item, {
                                label: "Valor Padrão",
                                class: "ss-margin-campos"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_selecionar_valor_campo_personalizado, {
                                    valores: _ctx.state.campo.itens,
                                    valor: _ctx.state.campo.valorPadrao,
                                    "onUpdate:valor": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.campo.valorPadrao) = $event))
                                  }, null, 8, ["valores", "valor"])
                                ]),
                                _: 1
                              })
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.state.campo.tipoCampo === _ctx.ETipoCampoPersonalizado.Data)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                            _createElementVNode("div", _hoisted_62, [
                              _createVNode(_component_a_form_item, {
                                label: "Valor Padrão",
                                class: "ss-margin-campos"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_selecionar_data, {
                                    dataSelecionada: _ctx.state.campo.valorPadrao,
                                    "onUpdate:dataSelecionada": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.state.campo.valorPadrao) = $event))
                                  }, null, 8, ["dataSelecionada"])
                                ]),
                                _: 1
                              })
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.state.campo.tipoCampo === _ctx.ETipoCampoPersonalizado.Hora)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                            _createElementVNode("div", _hoisted_64, [
                              _createVNode(_component_a_form_item, {
                                label: "Valor Padrão",
                                class: "ss-margin-campos"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_selecionar_hora, {
                                    horaSelecionada: _ctx.state.campo.valorPadrao,
                                    "onUpdate:horaSelecionada": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.state.campo.valorPadrao) = $event))
                                  }, null, 8, ["horaSelecionada"])
                                ]),
                                _: 1
                              })
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.validarTipoBoolean())
                        ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                            _createElementVNode("div", _hoisted_66, [
                              _createVNode(_component_a_form_item, {
                                label: "Valor Padrão",
                                class: "ss-margin-campos"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_selecionar_boolean, {
                                    descricaoTrue: "Marcado",
                                    descricaoFalse: "Desmarcado",
                                    valor: _ctx.state.valorPadraoBoolean,
                                    "onUpdate:valor": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.state.valorPadraoBoolean) = $event))
                                  }, null, 8, ["valor"])
                                ]),
                                _: 1
                              })
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_a_form_item, {
                        label: "Dica de preenchimento",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            maxlength: "250",
                            class: "ant-input",
                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.state.campo.tooltip) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.state.campo.tooltip]
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, {
                        label: "Informação sobre o campo",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("textarea", {
                            rows: "2",
                            class: "ant-input",
                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.state.campo.info) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.state.campo.info]
                          ])
                        ]),
                        _: 1
                      }),
                      (_ctx.state.campo.tipoCampo === _ctx.ETipoCampoPersonalizado.ComboBox || _ctx.state.campo.tipoCampo === _ctx.ETipoCampoPersonalizado.ListaSelecao)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                            _createVNode(_component_card, {
                              class: "ss-card",
                              titulo: "Itens"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_68, [
                                  _createElementVNode("div", _hoisted_69, [
                                    _createVNode(_component_a_form_item, {
                                      label: "Valor",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _withDirectives(_createElementVNode("input", {
                                          ref: "campoNovoItem",
                                          type: "text",
                                          class: "ant-input",
                                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.state.novoItem.valor) = $event))
                                        }, null, 512), [
                                          [_vModelText, _ctx.state.novoItem.valor]
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_70, [
                                    _createVNode(_component_a_form_item, {
                                      label: "Descrição",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "text",
                                          maxlength: "250",
                                          class: "ant-input",
                                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.state.novoItem.descricao) = $event))
                                        }, null, 512), [
                                          [_vModelText, _ctx.state.novoItem.descricao]
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_71, [
                                    _createVNode(_component_a_form_item, {
                                      label: " ",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: "ant-btn ant-btn-primary",
                                          style: {"min-height":"32px"},
                                          onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.adicionarItem && _ctx.adicionarItem(...args)))
                                        }, _hoisted_73)
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]),
                                _hoisted_74,
                                (_ctx.state.campo.itens.length <= 0)
                                  ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                                      key: 0,
                                      mensagem: "Nenhum item adicionado ainda"
                                    }))
                                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.state.campo.itens, (item, index) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        class: "ant-row ss-grade-personalizada-linha",
                                        key: index
                                      }, [
                                        _createElementVNode("div", _hoisted_75, [
                                          _createElementVNode("div", _hoisted_76, [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "text",
                                              class: "ant-input",
                                              "onUpdate:modelValue": ($event: any) => ((item.valor) = $event)
                                            }, null, 8, _hoisted_77), [
                                              [_vModelText, item.valor]
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_78, [
                                          _createElementVNode("div", _hoisted_79, [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "text",
                                              maxlength: "250",
                                              class: "ant-input",
                                              "onUpdate:modelValue": ($event: any) => ((item.descricao) = $event)
                                            }, null, 8, _hoisted_80), [
                                              [_vModelText, item.descricao]
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_81, [
                                          _createElementVNode("button", {
                                            type: "button",
                                            class: "ss-botao-remover ss-margin-campos ant-btn ant-btn-primary",
                                            title: "Remover",
                                            onClick: ($event: any) => (_ctx.removerItem(index,item.descricao))
                                          }, [
                                            _createVNode(_component_icone, {
                                              class: "ss-icone-remover",
                                              nome: "excluir"
                                            })
                                          ], 8, _hoisted_82)
                                        ])
                                      ]))
                                    }), 128))
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_a_form_item, {
                        label: "Mensagem de validação",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            maxlength: "250",
                            class: "ant-input",
                            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.state.campo.mensagemValidacao) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.state.campo.mensagemValidacao]
                          ])
                        ]),
                        _: 1
                      }),
                      (_ctx.validarTipoTexto())
                        ? (_openBlock(), _createBlock(_component_a_form_item, {
                            key: 8,
                            label: "Expressão regular",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "ant-input",
                                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.state.campo.expressaoRegular) = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.state.campo.expressaoRegular]
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.validarTipoTexto() || _ctx.state.campo.tipoCampo === _ctx.ETipoCampoPersonalizado.Senha)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                            _createElementVNode("div", _hoisted_84, [
                              _createVNode(_component_a_form_item, {
                                label: "Obrigatório",
                                class: "ss-margin-campos"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_selecionar_sim_nao, {
                                    valor: _ctx.state.campo.obrigatorio,
                                    "onUpdate:valor": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.state.campo.obrigatorio) = $event))
                                  }, null, 8, ["valor"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_85, [
                              _createVNode(_component_a_form_item, {
                                label: "Tamanho Máximo",
                                class: "ss-margin-campos"
                              }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "number",
                                    class: "ant-input",
                                    min: "1",
                                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.state.campo.tamanhoMaximo) = $event))
                                  }, null, 512), [
                                    [_vModelText, _ctx.state.campo.tamanhoMaximo]
                                  ])
                                ]),
                                _: 1
                              })
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_86, [
                            _createElementVNode("div", _hoisted_87, [
                              _createVNode(_component_a_form_item, {
                                label: "Obrigatório",
                                class: "ss-margin-campos"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_selecionar_sim_nao, {
                                    valor: _ctx.state.campo.obrigatorio,
                                    "onUpdate:valor": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.state.campo.obrigatorio) = $event))
                                  }, null, 8, ["valor"])
                                ]),
                                _: 1
                              })
                            ])
                          ])),
                      _createElementVNode("div", _hoisted_88, [
                        _createElementVNode("div", _hoisted_89, [
                          _createVNode(_component_a_form_item, {
                            label: "Exibir na consulta",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_sim_nao, {
                                valor: _ctx.state.campo.consulta,
                                "onUpdate:valor": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.state.campo.consulta) = $event))
                              }, null, 8, ["valor"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_90, [
                          _createVNode(_component_a_form_item, {
                            label: "Largura na consulta",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                percentual: true,
                                valor: _ctx.state.campo.tamanhoConsulta
                              }, null, 8, ["valor"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_91, [
                        _createElementVNode("div", _hoisted_92, [
                          _createVNode(_component_a_form_item, {
                            label: "Exibir no relatório",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_sim_nao, {
                                valor: _ctx.state.campo.relatorio,
                                "onUpdate:valor": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.state.campo.relatorio) = $event))
                              }, null, 8, ["valor"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_93, [
                          _createVNode(_component_a_form_item, {
                            label: "Largura no relatório",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                percentual: true,
                                valor: _ctx.state.campo.tamanhoRelatorio
                              }, null, 8, ["valor"])
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}